// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/system_management.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { SystemManagementService } from "./system_management";
import type { GetSystemManagementQuotaOverridesResponse } from "./system_management";
import type { GetSystemManagementQuotaOverridesRequest } from "./system_management";
import type { UpdateSystemManagementConfigResponse } from "./system_management";
import type { UpdateSystemManagementConfigRequest } from "./system_management";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetSystemManagementConfigResponse } from "./system_management";
import type { GetSystemManagementConfigRequest } from "./system_management";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.settings.v1.SystemManagementService
 */
export interface ISystemManagementServiceClient {
    /**
     * System Management Config methods
     *
     * @generated from protobuf rpc: GetSystemManagementConfig(c1.api.settings.v1.GetSystemManagementConfigRequest) returns (c1.api.settings.v1.GetSystemManagementConfigResponse);
     */
    getSystemManagementConfig(input: GetSystemManagementConfigRequest, options?: RpcOptions): UnaryCall<GetSystemManagementConfigRequest, GetSystemManagementConfigResponse>;
    /**
     * @generated from protobuf rpc: UpdateSystemManagementConfig(c1.api.settings.v1.UpdateSystemManagementConfigRequest) returns (c1.api.settings.v1.UpdateSystemManagementConfigResponse);
     */
    updateSystemManagementConfig(input: UpdateSystemManagementConfigRequest, options?: RpcOptions): UnaryCall<UpdateSystemManagementConfigRequest, UpdateSystemManagementConfigResponse>;
    /**
     * Quota Override methods
     *
     * @generated from protobuf rpc: GetSystemManagementQuotaOverrides(c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest) returns (c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse);
     */
    getSystemManagementQuotaOverrides(input: GetSystemManagementQuotaOverridesRequest, options?: RpcOptions): UnaryCall<GetSystemManagementQuotaOverridesRequest, GetSystemManagementQuotaOverridesResponse>;
}
/**
 * @generated from protobuf service c1.api.settings.v1.SystemManagementService
 */
export class SystemManagementServiceClient implements ISystemManagementServiceClient, ServiceInfo {
    typeName = SystemManagementService.typeName;
    methods = SystemManagementService.methods;
    options = SystemManagementService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * System Management Config methods
     *
     * @generated from protobuf rpc: GetSystemManagementConfig(c1.api.settings.v1.GetSystemManagementConfigRequest) returns (c1.api.settings.v1.GetSystemManagementConfigResponse);
     */
    getSystemManagementConfig(input: GetSystemManagementConfigRequest, options?: RpcOptions): UnaryCall<GetSystemManagementConfigRequest, GetSystemManagementConfigResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSystemManagementConfigRequest, GetSystemManagementConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSystemManagementConfig(c1.api.settings.v1.UpdateSystemManagementConfigRequest) returns (c1.api.settings.v1.UpdateSystemManagementConfigResponse);
     */
    updateSystemManagementConfig(input: UpdateSystemManagementConfigRequest, options?: RpcOptions): UnaryCall<UpdateSystemManagementConfigRequest, UpdateSystemManagementConfigResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSystemManagementConfigRequest, UpdateSystemManagementConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Quota Override methods
     *
     * @generated from protobuf rpc: GetSystemManagementQuotaOverrides(c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest) returns (c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse);
     */
    getSystemManagementQuotaOverrides(input: GetSystemManagementQuotaOverridesRequest, options?: RpcOptions): UnaryCall<GetSystemManagementQuotaOverridesRequest, GetSystemManagementQuotaOverridesResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSystemManagementQuotaOverridesRequest, GetSystemManagementQuotaOverridesResponse>("unary", this._transport, method, opt, input);
    }
}
